
document.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll('[data-reveal]');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  els.forEach((el) => io.observe(el));

  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.muted = true;
    const play = () => video.play().catch(() => {});
    play();
    document.addEventListener('visibilitychange', play);
  });
});
